import { render } from "./ChooseDumpster.vue?vue&type=template&id=583943ab"
import script from "./ChooseDumpster.vue?vue&type=script&lang=js"
export * from "./ChooseDumpster.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__